import React from 'react';
import {InputType} from '../../components/input/input.component';
import {FIXED_CHAR} from '../../components/fixedchar';



class MultiSparkline extends React.Component {
    constructor(){
          super();
          this.state = {
            data: {
              Maharastra: [5138973, 4469425, 76398],
              Telangana: [502187, 436619, 2771],
              "Tamil Nadu": [1409237, 1240968, 15880]
            },
            dataType: null,
            isManualError: false,
          }
       }
    isObjectEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return true;
        }
        return false;
    }
    convertFixed = (str)=>{
        let tmp = "";
        console.log(str);
        for(let i=0; i<str.length; i++) {
          tmp+=FIXED_CHAR[str[i]];
        }
        console.log(tmp);
        return tmp;
      }
    handleDropDownChange = (dataType)=>{
        this.setState({dataType: dataType, data: {}})
      }

    strip = (str)=>{
        return str.replace(/^\s+|\s+$/g, '');
      }

    handleInputChange=(event)=> {
        let currData = event.target.value.split("\n");
        let finalData = {}
        let curr, currValues, currKey;
        for(let i=0; i<currData.length; i++) {
          curr = currData[i].split(",");
          console.log(curr);
          currKey = this.strip(curr[0]);
          currValues  = []
          console.log(currKey);
          for(let j=1; j<curr.length; j++){
            if(j<curr.length-1 || parseInt(curr[j]))
                currValues.push(parseInt(curr[j]));
          }
          finalData[currKey] = currValues;
        }
        console.log(finalData);
        this.setState({data: finalData})
      }
    handleCSVUpload = (data, _)=> {
        let chartData = [];
        for(let i=0; i<data[0].length; i+=1) {
          chartData.push(parseInt(data[0][i]));
        }
        this.setState({data: chartData})
      }
    sparkline = function(series){
        let spark_chars = "▁▂▃▄▅▆▇█"
        let mn = Math.min.apply(Math, series)
        let mx = Math.max.apply(Math, series)
        let interval = Math.ceil((mx-mn)/7)
        let bucketed = []
        for(let i=0; i<series.length; i++) {
            bucketed.push(parseInt((series[i]-mn)/interval ))
        }
        let spark_dict = {}
        for(let i=0; i<8; i++) {
            spark_dict[i] = spark_chars[i]
        }
        let z = []
        for(let i=0; i<bucketed.length; i++) {
            z.push(spark_dict[bucketed[i]])
        }
        let separator;
        return z.join([separator=""])
      }
      createGraph = ()=>{
        let graph = [];
        let currgraphData = this.state.data;
        let keys = Object.keys(currgraphData);
        let longest = keys.reduce(
            function (a, b) {
                return a.length > b.length ? a : b;
            }
        );
        let fixedWidthKey;
        for(let key in currgraphData) {
            fixedWidthKey = this.convertFixed(key) + "．".repeat(longest.length-key.length+1);
            graph.push(fixedWidthKey + this.sparkline(currgraphData[key]));
        }
        let separator;
        graph = graph.join([separator="\n"])
        this.setState({graph: graph});
      }

    componentDidMount(){
      this.createGraph();
    }
    render() {
        let dataEntryType = null, graph=null;
        dataEntryType = <div className="col-4"> <InputType type="text" id="inputValues" placeholder={"Maharastra, 5138973, 4469425, 76398\nTelangana, 502187, 436619, 2771\nTamil Nadu, 1409237, 1240968, 15880\n"} label="Values" name="values" handleInputChange={this.handleInputChange} /> </div>
        
        return (
          <div className="container graph">
            <div className="row">
            <h3 className="col-2">Multi Sparkline</h3>
            {dataEntryType}
            <div className="col-2"><button className="btn btn-primary " onClick={this.createGraph}>Get chart</button></div>
            {this.state.graph ? <pre className="col-3">{this.state.graph}</pre>:<p className="col-3">No data exists</p> } 

        </div>
        </div>);

        }
}


export default MultiSparkline;